/* ÁGUAS DE IPANEMA — galeria do kit reage à variante escolhida

   A associação nativa (variant → featured_media) resolve o caso normal e é
   sempre a fonte preferida. Ela não cobre um caso: kit com VÁRIOS seletores da
   mesma peça — "Kit 3 Bases" tem três Base Stick, e uma variante é
   "Stick 10 / Stick 30 / Stick 60". Não existe UMA imagem da variante, então o
   Shopify não tem o que associar.

   Aqui vale a regra do último seletor: a galeria mostra a cor que a pessoa
   acabou de escolher, seja qual for o seletor. Trocar a imagem é só visual —
   não mexe em seleção, quantidade, preço nem no que vai para o carrinho.

   O mapa valor → mídia sai do nome do arquivo já publicado na galeria
   (20.jpg → "Stick 20", Incolor.jpg → "Incolor"), e só é usado quando a
   associação nativa não resolve. */
(function () {
  if (window.__aipKitVarMedia) return;
  window.__aipKitVarMedia = true;

  function galeria() { return document.querySelector('product-media'); }

  /* valor da opção -> media id, lido da galeria publicada */
  function construirMapa(pm) {
    var mapa = {};
    if (!pm || !pm.product || !pm.product.media) return mapa;
    pm.product.media.forEach(function (m) {
      var arq = String(m.src || '').split('/').pop().split('?')[0].replace(/\.[a-z0-9]+$/i, '');
      var base = arq.split('_')[0];
      if (/^\d{2}$/.test(base)) mapa['stick ' + base] = m.id;
      else if (/^incolor$/i.test(base)) mapa['incolor'] = m.id;
    });
    return mapa;
  }

  function irPara(pm, mediaId) {
    if (!pm || !mediaId) return;
    var alvo = pm.querySelector('[data-media-id="' + mediaId + '"]');
    if (!alvo) return;
    if (alvo.classList.contains('is-selected')) return;      /* já está lá */

    /* caminho nativo do tema; o thumbnail acompanha sozinho */
    if (pm.mainCarousel && typeof pm.mainCarousel.select === 'function') {
      pm.mainCarousel.select('[data-media-id="' + mediaId + '"]');
    }
    /* thumbnail fora da área visível: traz para a vista, sem pular a página */
    var th = document.querySelector('.product__thumbnail-item [data-media-id="' + mediaId + '"], .product__thumbnail-item#thumbnail-' + mediaId);
    var cx = th && th.closest('[class*="thumbnail-list"], [class*="thumbnails"]');
    if (th && cx && cx.scrollHeight > cx.clientHeight + 4) {
      try { th.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
    }
  }

  /* qual valor de opção acabou de ser escolhido neste controle */
  function valorDe(el) {
    if (!el) return null;
    if (el.tagName === 'SELECT') return el.options[el.selectedIndex] && el.options[el.selectedIndex].text.trim();
    if (el.type === 'radio' || el.type === 'checkbox') {
      var lab = el.closest('label') || document.querySelector('label[for="' + el.id + '"]');
      return (el.value || (lab && lab.textContent) || '').trim();
    }
    return (el.value || '').trim();
  }

  function reagir(ev) {
    var pm = galeria();
    if (!pm || !pm.product) return;

    /* mais de um seletor para a MESMA opção? aí a associação nativa não basta */
    var v = valorDe(ev.target);
    if (!v) return;
    var chave = v.toLowerCase();
    var mapa = pm.__aipMapa || (pm.__aipMapa = construirMapa(pm));
    if (!mapa[chave]) return;              /* valor sem imagem: não force nada */

    /* só assume o controle quando o produto tem MAIS DE UMA opção — com uma
       opção só, quem manda é a associação nativa e não se mexe. */
    if (!pm.product.options || pm.product.options.length < 2) return;

    irPara(pm, mapa[chave]);
  }

  document.addEventListener('change', reagir, true);
  document.addEventListener('click', function (e) {
    var alvo = e.target.closest && e.target.closest('[data-option-value], .color-swatch, [class*="swatch"]');
    if (alvo) setTimeout(function () { reagir({ target: alvo.querySelector('input') || alvo }); }, 60);
  }, true);
})();
